import React, { useState } from 'react'
import PropTypes from 'prop-types'
import Input from '../../common/Input/index'
import Button from '../../common/Button/index'

const RegistrationForm = ({ onSubmit, error }) => {
  const [full_name, setName] = useState('')
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [confirmPassword, setConfirmPassword] = useState('')

  const handleSubmit = e => {
    e.preventDefault()

    if (password !== confirmPassword) {
      return onSubmit({ error: 'Passwords do not match' })
    }

    onSubmit({ full_name, email, password })
  }

  return (
    <form
      onSubmit={handleSubmit}
      className="w-full mx-auto p-2 sm:p-4 md:p-6"
    >
      <h2 className="text-center text-dark text-xl sm:text-2xl font-semibold mb-4 sm:mb-6">Register New Account</h2>
      <div className="flex flex-col gap-3 sm:gap-4">
        <Input
          name="full_name"
          type="text"
          value={full_name}
          onChange={e => setName(e.target.value)}
          placeholder="Enter full name"
          className="text-sm sm:text-base"
          required
        />
        <Input
          name="email"
          type="email"
          value={email}
          onChange={e => setEmail(e.target.value)}
          placeholder="Enter email"
          className="text-sm sm:text-base"
          required
        />
        <Input
          name="password"
          type="password"
          value={password}
          onChange={e => setPassword(e.target.value)}
          placeholder="Enter password"
          className="text-sm sm:text-base"
          required
        />
        <Input
          name="confirm_password"
          type="password"
          value={confirmPassword}
          onChange={e => setConfirmPassword(e.target.value)}
          placeholder="Confirm password"
          className="text-sm sm:text-base"
          required
        />
        {error && (
          <div className="text-danger text-xs sm:text-sm text-center p-2 sm:p-3 rounded bg-red-50" role="alert">
            {error}
          </div>
        )}
        <Button variant="primary" type="submit" className="mt-2 w-full text-sm sm:text-base py-2 sm:py-3">
          Register
        </Button>
      </div>
    </form>
  )
}

RegistrationForm.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  error: PropTypes.string,
}

export default RegistrationForm
